import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import { AttachmentIcon, generateCustomFileForUpload, handleAllError, ViewFile } from "../CustomFunctions";
import { Modal } from "react-bootstrap";
import { Card, CloudUpload } from "../AllSvg";
import Loader from "../Loader";

const AddBankDetails = ({ code, extra_close }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        extra_close(false)
        setShow(false)
    };

    const handleShow = () => {
        setShow(true);
        getBankData(code)
    };

    const getBankData = async (emp_code) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/userBankDetailsgetall/${emp_code}/`
            );
            setFormData(res.data);
        } catch (err) {
            // alert(err)
            // handleAllError(err)
        }
    };

    const [formData, setFormData] = useState({
        user: code,
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        branch_address: "",
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "account_number",
            "ifsc_code",
            "bank_name",
            "branch_address",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    useEffect(() => { }, [formData]);

    const [loading, setLoading] = useState(false); //loading logic
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/userBankDetails/`,
                    formData
                );

                if (res.status === 200) {
                    await getBankData(code);
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err);
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/userBankDetails/${code}/`,
                    formData
                );

                if (res.status === 200) {
                    await getBankData(code);
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err)
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
                title="Add Bank Details"
                onClick={handleShow}
            >
                <Card /> Bank Details
            </button>

            <Modal
                show={show}
                onHide={loading ? null : handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Bank Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            <div className="flex-column">
                                <label htmlFor="user" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Employee Code
                                </label>
                                <input
                                    id="user"
                                    type="text"
                                    name="user"
                                    placeholder={formData.user}
                                    onChange={handleInputChange}
                                    readOnly
                                    value={formData.user}
                                    className={`form-input ${errors.user ? "error" : inputState.user ? "success" : ""
                                        }`}
                                />
                                {errors.user && (
                                    <span className="error-message font-size-text ">{errors.user}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="account_number"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Account No.
                                </label>
                                <input
                                    id="account_number"
                                    name="account_number"
                                    type="number"
                                    onChange={handleInputChange}
                                    // placeholder="00000"
                                    value={formData.account_number}
                                    className={`form-input ${errors.account_number
                                        ? "error"
                                        : inputState.account_number
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.account_number && (
                                    <span className="error-message font-size-text ">{errors.account_number}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="ifsc_code"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    IFSC
                                </label>
                                <input
                                    id="ifsc_code"
                                    // type=""
                                    name="ifsc_code"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.ifsc_code}
                                    className={`form-input ${errors.ifsc_code
                                        ? "error"
                                        : inputState.ifsc_code
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.ifsc_code && (
                                    <span className="error-message font-size-text ">{errors.ifsc_code}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="bank_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Bank Name
                                </label>
                                <input
                                    id="bank_name"
                                    // type=""
                                    name="bank_name"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.bank_name}
                                    className={`form-input ${errors.bank_name
                                        ? "error"
                                        : inputState.bank_name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.bank_name && (
                                    <span className="error-message font-size-text ">{errors.bank_name}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="branch_address"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Branch Address
                                </label>
                                <input
                                    id="branch_address"
                                    // type=""
                                    name="branch_address"
                                    // placeholder="00000"
                                    onChange={handleInputChange}
                                    value={formData.branch_address}
                                    className={`form-input ${errors.branch_address
                                        ? "error"
                                        : inputState.branch_address
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.branch_address && (
                                    <span className="error-message font-size-text ">{errors.branch_address}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button
                                    className="model-button   font-weight500   "
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>

                                {formData.account_number ? (
                                    <button
                                        type="submit"
                                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                        onClick={handleUpdate}
                                        disabled={loading}
                                    >
                                        Update
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        Add
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const BankDetailsWithApprovalRequest = ({ code, extra_close }) => {
    const [show, setShow] = useState(false);
    const [bankData, setBankData] = useState(null); // current saved bank details
    const [pendingRequest, setPendingRequest] = useState(null); // holds active request if exists
    const [formData, setFormData] = useState({
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        branch_address: "",
        proof_attachment: null,
        reason_for_change: "",
    });
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [buffer2, setBuffering2] = useState(true); //buffering logic

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleClose = () => {
        extra_close?.(false);
        setShow(false);
    };

    const handleShow = () => {
        setShow(true);
        getBankData(code);
        getPendingRequest(code)
    };

    const getBankData = async (emp_code) => {
        setBuffering1(true)
        try {
            const res = await axios.get(`${BASE_URL}/wfm/userBankDetailsgetall/${emp_code}/`);
            setBankData(res.data || null);
            setFormData(res.data || {
                account_number: "",
                ifsc_code: "",
                bank_name: "",
                branch_address: "",
                proof_attachment: null,
                reason_for_change: "",
            });
        } catch (err) {
            setBankData(null);
        } finally {
            setBuffering1(false)
        }
    };

    const getPendingRequest = async (emp_code) => {
        setBuffering2(true)
        try {
            const logRes = await axios.get(`${BASE_URL}/wfm/bank-details-log-by-emp/${emp_code}/null/`);
            const activeRequest = logRes.data?.find(r => r.status === "pending");
            if (activeRequest) {
                setPendingRequest(activeRequest);
            } else {
                setPendingRequest(null);
            }
        } catch (err) {
            setPendingRequest(null);
        } finally {
            setBuffering2(false)
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "account_number",
            "ifsc_code",
            "bank_name",
            "branch_address",
            "proof_attachment",
            "reason_for_change",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Submitting request...");
            try {

                const changed_fields = Object.keys(formData).filter(
                    (key) => key !== "proof_attachment" && key !== "user" && key !== "reason_for_change" &&
                        (!bankData || formData[key] !== bankData[key])
                );

                const uploadData = new FormData();

                uploadData.append("emp_code", code);
                uploadData.append("reason_for_change", formData.reason_for_change);

                Object.entries(bankData || {}).forEach(([key, value]) => {
                    if (key !== "user") {
                        uploadData.append(`previous_data[${key}]`, value ?? "");
                    }
                });

                Object.entries(formData).forEach(([key, value]) => {
                    if (key !== "proof_attachment" && key !== "reason_for_change" && key !== "user") {
                        uploadData.append(`updated_data[${key}]`, value ?? "");
                    }
                });
                changed_fields.forEach((field) => {
                    uploadData.append("changed_fields[]", field);
                });

                const attachmentFile = formData.proof_attachment;
                if (attachmentFile && typeof attachmentFile !== 'string') {
                    const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                    uploadData.append("proof_attachment", customFile);
                }

                const res = await axios.post(`${BASE_URL}/wfm/bank-details-log-dynamic/`, uploadData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    toast.success("Change request submitted for approval.");
                    handleClose();
                } else {
                    toast.error("Something went wrong.");
                }
            } catch (err) {
                toast.error("Error submitting request.");
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const [showUpdateInputs, setShowUpdateInputs] = useState(false);

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button
                className="flex items-center gap-3 p-2 font-size-text rounded-md hover:bg-gray-100 cursor-pointer transition"
                title="Bank Details"
                onClick={handleShow}
            >
                <Card width={20} height={20} color="#2576BC" /> <span style={{ marginTop: '3px' }}>Bank Details</span>
            </button>

            <Modal
                show={show}
                onHide={loading ? null : handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {bankData ? "Current Bank Details" : "Add Bank Details"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        buffer1 || buffer2 ?
                            <Loader container={true} />
                            :
                            <>
                                {bankData ? (
                                    <>
                                        <div className="flex-row justify-between">
                                            <h6 className="mt-3">Current Details</h6>
                                            {!pendingRequest && <div className="flex-row">
                                                <label className="form-labels">
                                                    Request Changes
                                                    {/* {showUpdateInputs ? "Shown" : "Hidden"} : {" "} */}
                                                </label>
                                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                <div className="checkbox-toggle">
                                                    <input
                                                        type="checkbox"
                                                        id="toggle-employees"
                                                        name="show_emp_data"
                                                        checked={showUpdateInputs}
                                                        onChange={() => setShowUpdateInputs(!showUpdateInputs)}
                                                    />
                                                    <label htmlFor="toggle-employees"></label>
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="mb-4">
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <tbody>
                                                    {[
                                                        { label: "Account No", value: bankData.account_number },
                                                        { label: "IFSC", value: bankData.ifsc_code },
                                                        { label: "Bank", value: bankData.bank_name },
                                                        { label: "Branch", value: bankData.branch_address }
                                                    ].map(({ label, value }) => (
                                                        <tr key={label}>
                                                            <td className="font-weight500" >{label}</td>
                                                            <td >:</td>
                                                            <td className="pl-10">{value || "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <hr />
                                        </div>
                                    </>
                                ) : (
                                    <p className="mb-3 text-gray-500">No bank details found. Please add new details.</p>
                                )}

                                {pendingRequest ? (
                                    <>
                                        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md text-yellow-700">
                                            <strong>Request already in process:</strong> Your previous bank details change is still under approval.
                                            <br />
                                            <small>Status: {pendingRequest.status}</small>
                                        </div>
                                        <h6 className="mt-3">Requested New Details</h6>
                                        <div className="mb-4">
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <tbody >
                                                    {[
                                                        { label: "Account No", value: pendingRequest.updated_data?.account_number },
                                                        { label: "IFSC", value: pendingRequest.updated_data?.ifsc_code },
                                                        { label: "Bank", value: pendingRequest.updated_data?.bank_name },
                                                        { label: "Branch", value: pendingRequest.updated_data?.branch_address }
                                                    ].map(({ label, value }) => (
                                                        <tr key={label}>
                                                            <td className="font-weight500">{label}</td>
                                                            <td>:</td>
                                                            <td className="pl-10">{value || "-"}</td>
                                                        </tr>
                                                    ))}
                                                    <tr >
                                                        <td className="font-weight500" >Proof for Changes</td>
                                                        <td >:</td>
                                                        <td className="pl-10">
                                                            {pendingRequest.proof_attachment ? (
                                                                <ViewFile
                                                                    doc={pendingRequest.proof_attachment}
                                                                    filename={"Proof Attachment"}
                                                                    filesrc={pendingRequest.proof_attachment}
                                                                />
                                                            ) : (
                                                                'No File Attached'
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                ) : (
                                    showUpdateInputs || !bankData ?
                                        <>
                                            <h6 className="mt-3">New Details </h6>
                                            <form>
                                                {["account_number", "ifsc_code", "bank_name", "branch_address", "reason_for_change"].map((field) => (
                                                    <div key={field} className="flex-column mb-3">
                                                        <label className="form-labels font-weight500 font-size-heading">
                                                            {field.replace(/_/g, " ").toUpperCase()}<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            name={field}
                                                            value={formData[field]}
                                                            onChange={handleInputChange}
                                                            className={`form-input ${errors[field] ? "error" : ""}`}
                                                        />
                                                        {errors[field] && (
                                                            <span className="error-message">{errors[field]}</span>
                                                        )}
                                                    </div>
                                                ))}

                                                <div className="flex-column mt-3 mb-3">
                                                    <label
                                                        htmlFor="proof_attachment"
                                                        className="form-labels font-weight500 font-size-subheading text-uppercase"
                                                    >
                                                        Proof Attachment (Cancel Cheque / Bank Statement)<span className="required">*</span>
                                                    </label>
                                                    <div
                                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                                        style={{ padding: "0 3px" }}
                                                    >
                                                        <label
                                                            className="popup-label"
                                                            htmlFor="proof_attachment"
                                                        >
                                                            <CloudUpload />
                                                            <span className="truncate-url">
                                                                {formData?.proof_attachment
                                                                    ? formData?.proof_attachment instanceof File
                                                                        ? formData?.proof_attachment.name
                                                                        : getFileNameFromUrl(formData?.proof_attachment)
                                                                    : "No file selected"}
                                                            </span>
                                                        </label>

                                                        <input
                                                            type="file"
                                                            id="proof_attachment"
                                                            name="proof_attachment"
                                                            accept=".pdf, .doc, .docx, .png, .jpeg, .jpg, image/*"
                                                            onChange={handleFileChange}
                                                            className="popup-input"

                                                        />
                                                        <br />
                                                        {formData?.proof_attachment && (
                                                            <span
                                                                className="file-clear"
                                                                onClick={() => handleFileClear("proof_attachment")}
                                                            >
                                                                Clear
                                                            </span>
                                                        )}
                                                        <div>
                                                            {errors.proof_attachment && (
                                                                <span className="error-message font-size-text ">
                                                                    {errors.proof_attachment}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="button-models flex justify-end gap-2 mt-4">
                                                    <button
                                                        type="button"
                                                        className="model-button model-button-cancel"
                                                        onClick={handleClose}
                                                        disabled={loading}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="model-button model-button-leave"
                                                        onClick={handleSubmit}
                                                        disabled={loading}
                                                    >
                                                        {bankData ? "Submit Change Request" : "Add Bank Details"}
                                                    </button>
                                                </div>
                                                <p className="error-message font-size-text">
                                                    {isSubmitted && Object.keys(errors).length > 0 && (
                                                        Object.keys(errors).length > 5 ? (
                                                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                                                        ) : (
                                                            <h6 className="text-center">
                                                                {Object.keys(errors)
                                                                    .map((field) =>
                                                                        field
                                                                            .replace(/_/g, ' ')
                                                                            .replace(/\b\w/g, (char) => char.toUpperCase())
                                                                    )
                                                                    .join(', ') + ' are required!'}
                                                            </h6>
                                                        )
                                                    )}
                                                </p>
                                            </form>
                                        </>
                                        : null
                                )}
                            </>
                    }
                </Modal.Body>
            </Modal>
        </>
    );
};

export { AddBankDetails, BankDetailsWithApprovalRequest }